var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "image-block"
  }, [_c('h3', {
    staticClass: "image-title"
  }, [_vm._v(_vm._s(_vm.title))]), _c('img', {
    staticClass: "info-image",
    attrs: {
      "src": _vm.src,
      "alt": _vm.alt
    }
  })]);
}
var staticRenderFns = []

export { render, staticRenderFns }